import { createContext, useContext } from 'react'
import noop from '~/lib/noop'
import type { GlobalMessageType } from '~/lib/globalMessage'

export const GlobalMessageDispatchContext = createContext<((type: GlobalMessageType, message: string) => void)>(noop)

export function useGlobalMessageDispatch() {
  return useContext(GlobalMessageDispatchContext)
}
